import { Observable } from '../Observable';
import { scanInternals } from './scanInternals';
export function scan(accumulator, seed) {
    var hasSeed = arguments.length >= 2;
    return function (source) { return new Observable(function (subscriber) { return scanInternals(accumulator, seed, hasSeed, true, false, source, subscriber); }); };
}
//# sourceMappingURL=scan.js.map